import { AxiosError, AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";

// Response / Request
import { KeyValueDefault } from "@/main/models/common";
import { Result } from "@models/common/resultResponse";

// Redux
import { GetIntegrationTriggers, saveIntegrationTrigger } from "./index";

// Api's
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { integrationTriggerApi } from "../../api";

export function* getIntegrationTriggerSaga(_action: GetIntegrationTriggers) {
	try {
		const response: AxiosResponse<Result<KeyValueDefault[]>> = yield call(integrationTriggerApi.getDomain);
		if (response.data.result) {
			yield put(saveIntegrationTrigger(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
			yield put(saveIntegrationTrigger(null, true, resultError.messagesDataError));
		}
	}
}
